<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title" *ngIf="header !== ''">{{ header }}</div>
    <div class="sopo-popup-text" *ngIf="body !== ''">{{ body }}</div>
    <div class="sopo-popup-input-container">
        <input 
            class="sopo-popup-input"
            [placeholder]="firstPlaceholder" 
            autocomplete="off" 
            spellcheck="false" 
            [(ngModel)]="firstInput" 
            type="text"
            *ngIf="firstPlaceholder !== ''" 
            (keyup.enter)="close()"
            />
        <input
            class="sopo-popup-input"
            [placeholder]="secondPlaceholder" 
            autocomplete="off" 
            spellcheck="false" 
            [(ngModel)]="secondInput" 
            type="text" 
            *ngIf="secondPlaceholder !== ''"
            (keyup.enter)="close()"
            />
    </div>
    <div class="sopo-popup-text" *ngIf="note !== ''">{{ note }}</div>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button ion-activatable clickable" (click)="close()" *ngIf="okText !== ''">
            {{ okText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
        <div class="sopo-popup-red-button ion-activatable clickable" (click)="close(true)" *ngIf="cancelText !== ''">
            {{ cancelText }}
            <ion-ripple-effect></ion-ripple-effect>
        </div>
    </div>
</div>
